import { c as _c } from "react/compiler-runtime";
import { useHistory, useLocation } from 'react-router-dom';
import { parseQuery, stringifyQuery } from '../../utils';
const useSearchQuery = t0 => {
  const $ = _c(15);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} as T : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const defaults = t1;
  const history = useHistory();
  const {
    pathname,
    search
  } = useLocation();
  let t2;
  if ($[2] !== search) {
    t2 = parseQuery(search);
    $[2] = search;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== defaults || $[5] !== t2) {
    t3 = {
      ...defaults,
      ...t2
    };
    $[4] = defaults;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const query = t3 as T;
  let t4;
  if ($[7] !== history || $[8] !== pathname || $[9] !== query || $[10] !== search) {
    t4 = (query_params, t5) => {
      const {
        remove_keys: t6,
        replace: t7
      } = t5 === undefined ? {} : t5;
      const remove_keys = t6 === undefined ? [] : t6;
      const replace = t7 === undefined ? false : t7;
      const new_query = replace ? query_params : {
        ...query,
        ...query_params
      };
      remove_keys.forEach(key => delete new_query[key]);
      const new_query_string = `?${stringifyQuery(new_query)}`;
      if (search !== new_query_string) {
        history.push(`${pathname}${new_query_string}`);
      }
    };
    $[7] = history;
    $[8] = pathname;
    $[9] = query;
    $[10] = search;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const updateSearchQuery = t4;
  let t5;
  if ($[12] !== query || $[13] !== updateSearchQuery) {
    t5 = {
      query,
      updateSearchQuery
    };
    $[12] = query;
    $[13] = updateSearchQuery;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export default useSearchQuery;